import { render, staticRenderFns } from "./MedicalRejectedApplications.vue?vue&type=template&id=5f616844"
import script from "./MedicalRejectedApplications.vue?vue&type=script&lang=js"
export * from "./MedicalRejectedApplications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports